import { useState, useRef, useEffect } from 'react';

// Ícono de ayuda (ⓘ) que muestra una explicación breve al pasar el mouse
// o al tocarlo (en móvil). Uso:
//   <Tooltip texto="Explicación del campo" />
//   <span>Envío por Adelantado <Tooltip texto="..." /></span>

export default function Tooltip({ texto }) {
  const [visible, setVisible] = useState(false);
  const ref = useRef(null);

  // Cerrar al tocar fuera (para el modo táctil)
  useEffect(() => {
    if (!visible) return;
    const handleClickFuera = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setVisible(false);
      }
    };
    document.addEventListener('mousedown', handleClickFuera);
    return () => document.removeEventListener('mousedown', handleClickFuera);
  }, [visible]);

  return (
    <span className="relative inline-flex items-center" ref={ref}>
      <button
        type="button"
        onClick={() => setVisible(v => !v)}
        onMouseEnter={() => setVisible(true)}
        onMouseLeave={() => setVisible(false)}
        className="text-gray-400 hover:text-blue-600 transition-colors focus:outline-none"
        aria-label="Más información"
      >
        <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      </button>
      {visible && (
        <span className="absolute left-1/2 -translate-x-1/2 bottom-full mb-2 z-50 w-56 px-3 py-2 text-xs font-normal text-white bg-gray-800 rounded-lg shadow-lg text-left leading-snug">
          {texto}
          <span className="absolute left-1/2 -translate-x-1/2 top-full w-0 h-0 border-l-4 border-r-4 border-t-4 border-l-transparent border-r-transparent border-t-gray-800"></span>
        </span>
      )}
    </span>
  );
}
